{
  "version": 1,
  "asset_id": "27788dca-0fbc-4e4c-8e38-cb8e6ac1e8b1",
  "project_id": "323b9e15-9042-4162-b531-66ca33513bd6",
  "url": "/__l5e/assets-v1/27788dca-0fbc-4e4c-8e38-cb8e6ac1e8b1/td-logo.jpeg",
  "r2_key": "a/v1/323b9e15-9042-4162-b531-66ca33513bd6/27788dca-0fbc-4e4c-8e38-cb8e6ac1e8b1/td-logo.jpeg",
  "original_filename": "td-logo.jpeg",
  "size": 102639,
  "content_type": "image/jpeg",
  "created_at": "2026-07-13T05:30:32Z"
}
